import Button from "rivals/components/shared/Button";
import Checkbox from "rivals/components/shared/Form/Checkbox";
import SubscriptionTerms, {
  FreeTerms
} from "rivals/components/shared/Subscription/SubscriptionTerms";
import styles from "./TermsOfService.module.scss";
import strings from "./strings";
import { Props } from "./types";

const { rivalsEmailsAgreement, thirdPartyEmailsAgreement } = strings;

function TermsOfService({
  buttonDisabled,
  debitAgreement,
  handleSubmit,
  isPaid = false,
  submitButtonText,
  tosAgreements
}: Props): JSX.Element {
  return (
    <div className={styles.terms}>
      {tosAgreements && (
        <>
          <Checkbox
            className={styles.firstCheckbox}
            data="create-account-rivals-marketing-emails"
            isChecked={tosAgreements.rivalsEmailsAgreed}
            label={rivalsEmailsAgreement}
            onChange={tosAgreements.handleRivalsEmailAgreement}
          />
          <Checkbox
            data="create-account-third-party-emails"
            isChecked={tosAgreements.thirdPartyEmailsAgreed}
            label={thirdPartyEmailsAgreement}
            onChange={tosAgreements.handleThirdPartyEmailAgreement}
          />
        </>
      )}
      {debitAgreement}
      {isPaid ? <SubscriptionTerms /> : <FreeTerms />}
      <Button
        buttonText={submitButtonText}
        className={styles.subscribeButton}
        data="subscriptions-new-submit"
        disabled={buttonDisabled}
        inverted
        onClick={handleSubmit}
      />
    </div>
  );
}

export default TermsOfService;
